export default __webpack_public_path__ + "static/media/LYRA.c3f22fab.webp";